import script from "./AdBrandTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdBrandTable.vue?vue&type=script&setup=true&lang=js"

import "./AdBrandTable.vue?vue&type=style&index=0&id=f63fe528&lang=scss"

const __exports__ = script;

export default __exports__